export const SpaceCooperationService = Symbol.for('SpaceCooperationService');
